import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import { LoggingPluginInterface } from './definitions';
import { CAPACITOR_AMPLITUDE_PLUGIN } from '../pluginConstants';

const AmplitudeCapacitorPluginRaw = registerPlugin<LoggingPluginInterface>(CAPACITOR_AMPLITUDE_PLUGIN);
const AmplitudeCapacitorPlugin = withBridgedStackTrace(AmplitudeCapacitorPluginRaw, CAPACITOR_AMPLITUDE_PLUGIN);

export * from './definitions';
export { AmplitudeCapacitorPlugin };
